import { Card, CardBody, Col } from 'reactstrap'
import { H4, SVG } from '../../../../AbstractElements'
import { purchaseData } from '../../../../Data/Widgets/GeneralWidgetsData'

const PurchaseWidget = () => {
  return (
    <>
      {purchaseData.map((data,i)=>(
        <Col sm="6" xl="3" className="box-col-6" key={i}>
          <Card className="widget-1">
            <CardBody>
              <div className="widget-content">
                <div className={`widget-round ${data.color}`}>
                  <div className="bg-round">
                    <SVG className="svg-fill" iconId={data.svg} />
                    <SVG className="half-circle svg-fill" iconId={data.svg2}/>
                  </div>
                </div>
                <div>
                  <H4>{data.count}</H4>
                  <span className="f-light">{data.title}</span>
                </div>
              </div>
              <div className={`font-${data.color} f-w-500`}>
                <i className={`${data.icon} icon-rotate me-1`} />
                <span>{data.result}</span>
              </div>
            </CardBody>
          </Card>
        </Col>
      ))}
    </>
  )
}

export default PurchaseWidget